import OPayPanelViewState from './schema/OPayPanelViewState';
import { createStore } from 'satcheljs';

const initialOPayPanelViewState: OPayPanelViewState = {
    shouldShowModalFlexPane: false,
    modalFlexPaneContent: undefined,
};

const store = createStore<OPayPanelViewState>('OPayPanel', initialOPayPanelViewState)();

export default store;
